import React, {memo} from "react";
import AssetItemInfo from "../AssetItemInfo";
import AssetItemThumbnail from "../AssetItemThumbnail";

function AssetItem({data, appearance}) {
  return (
    <AssetItemInfo data={data}>
      <AssetItemThumbnail appearance={appearance} asset={data} duration={data?.duration} thumbnail={data?.thumbnailUrl} />
    </AssetItemInfo>
  );
}

export default memo(AssetItem);
